/**
 * i18next initialization — side-effect module.
 * Import this file to ensure i18next is configured before use.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import {
  DEFAULT_LOCALE,
  FALLBACK_LOCALE,
  NAMESPACES,
  SUPPORTED_LOCALES,
} from './config';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED_LOCALES,
    fallbackLng: FALLBACK_LOCALE,
    lng: DEFAULT_LOCALE,
    defaultNS: 'common',
    ns: [...NAMESPACES],

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
